export function twoDecimalPlacesIfCents(amount: number) {
	return amount % 1 !== 0 ? amount.toFixed(2) : amount;
}
/**
 * @description parse number from unknown value, return value in min/max boundary with some step and fixed numbers after zero
 * @param props
 * @returns
 */
export const validateNumber = (props: {
	validateValue: unknown;
	min: number;
	max: number;
	step: number;
	numbersAfterZero: number;
}) => {
	const { validateValue, min, max, step, numbersAfterZero } = props;

	let number = Number(validateValue);
	if (Number.isNaN(number)) {
		return min;
	}

	number = Number(snapNumber(number, step).toFixed(numbersAfterZero));

	return Math.min(Math.max(number, min), max);
};
export const snapNumber = (value: number, step: number) => {
	return Math.round(value / step) * step;
};
/**
 * @description intrepolate number from one range to another
 * @param val
 * @param minVal
 * @param maxVal
 * @param newMin
 * @param newMax
 * @returns
 */
export const normalizeNumberBetweenRange = (
	val: number,
	minVal: number,
	maxVal: number,
	newMin: number,
	newMax: number
) => newMin + ((val - minVal) * (newMax - newMin)) / (maxVal - minVal);

/**
 * @description Calculate the percentage of a value within a given range
 * @param min - The minimum value of the range
 * @param max - The maximum value of the range
 * @param actual - The actual value to calculate the percentage for
 * @returns The percentage of the actual value within the range
 */
export function calculatePercentage(min: number, max: number, actual: number) {
	const range = max - min;
	const valueRelativeToMin = actual - min;
	const percentage = (valueRelativeToMin / range) * 100;
	return Math.min(Math.max(Math.round(percentage), 0), 100);
}

export function clampNumber(number: number, min: number, max: number): number {
	return Math.max(Math.min(number, min), max);
}

export function formatNumberWithSpaces(number: number): string {
	return new Intl.NumberFormat("fr-FR").format(number);
}
